const locale = {
    placeholder: 'Selezionare l\'orario',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/it_IT.tsx